import { Map as iMap } from 'immutable';

const uiRootReducer = (reducer, type) => {
  const initialState = iMap({
    isOpen: false,
    isSyncing: false,
    message: '',
  });

  return (state = initialState, action) => {
    const OPEN = `${type}_OPEN`;
    const CLOSE = `${type}_CLOSE`;
    const SYNC_DATA = `${type}_SYNC_DATA`;
    const SYNC_SUCCESS = `${type}_SYNC_SUCCESS`;
    const SYNC_FAILURE = `${type}_SYNC_FAILURE`;

    switch (action.type) {
      case OPEN:
        return state.merge(iMap({ isOpen: true }));
      case SYNC_DATA:
        return state.merge(iMap({ isSyncing: true }));
      case SYNC_SUCCESS:
        return state.merge(iMap({ isSyncing: false, ...action.payload }));
      case SYNC_FAILURE:
        return state.merge(iMap({ isSyncing: false, ...action.payload }));
      case CLOSE:
        return state.merge(iMap({ isOpen: false }));
      default:
        return reducer(state, action);
    }
  };
};

export default uiRootReducer;



// WEBPACK FOOTER //
// ./src/app/stores/ui/ui-enhancer.js